import { MESSAGE_TYPE } from "@/constants";

export default function (name) {
  return MESSAGE_TYPE[name] || "Clean";
}
